import React from 'react';
import {View} from 'MWC';
import tpl from '../templates/top.jsx';
import widgetsHelper from 'utils/getWidget.helper';
import buildUrl from 'utils/buildGetURLWithParams';
import {apiback} from '../../../config';
import {canUseDOM} from '../../../helpers/canUseDOM';

export default class extends View {
    templates = {
        [this.uiStates.INITIAL]: tpl,
        [this.uiStates.INTERACTIVE]: tpl,
        [this.uiStates.ERROR]: tpl,
        [this.uiStates.STANDBY]: tpl
    };

    constructor(props) {
        super(props);

        this.tabs = {
            RULERS: 'rulers',
            SUPERVISORS: 'supervisors'
        };

        this.state = {
            ui: this.uiStates.INTERACTIVE,
            tab: this.tabs.RULERS,
            loader: true,
            widgets: [],
            where_by: ['path'],
            search_by: ['/about/top/2023'],
            widgets_2: [],
            where_by_2: ['path'],
            search_by_2: ['/about/top/2024'],
            widgets_3: [],
            where_by_3: ['path'],
            search_by_3: ['/about/top/2025'],
            widgets_4: [],
            widgets_4_loading: true,
            data: []
        };
        this.widgetsHelper = widgetsHelper;
        return this;
    }

    componentWillMount() {
        if (canUseDOM) return;
        const {ssrData} = this.props;
        if (ssrData) {
            this.setState({
                widgets: ssrData.widgets || [],
                widgets_2: ssrData.widgets_2 || [],
                widgets_3: ssrData.widgets_3 || [],
                widgets_4: ssrData.widgets_4 || [],
                loader: false,
                widgets_4_loading: false
            });
        }
    }

    componentDidMount() {
        this.widgetsHelper.getWidgets.call(this);
        this.widgetsHelper.getWidgets_2.call(this);
        this.widgetsHelper.getWidgets_3.call(this);
        this.widgetsHelper.getWidgetsByPath.call(this, {
            path: '/about/top/2026',
            widgetKey: 'widgets_4'
        });
    }

    changeFilesUrl(url) {
        return apiback('API_PAGES') + url.slice(7);
    }

    switchTab(tab) {
        return this.setState({tab});
    }

    static displayName = 'About.Views.Top';
}
